import React from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { EventSelector } from './EventSelector';

interface EventSwitchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEventSelect: (eventId: string) => void;
}

export function EventSwitchModal({ isOpen, onClose, onEventSelect }: EventSwitchModalProps) {
  const handleEventSelect = (eventId: string) => {
    onEventSelect(eventId);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      title="Switch Event"
      description="Select a different event to work on"
    >
      <div className="-mx-6 px-6">
        <EventSelector onEventSelect={handleEventSelect} />
      </div>
    </Modal>
  );
}

